import { render, staticRenderFns } from "./NewLines.vue?vue&type=template&id=1834e020&"
import script from "./NewLines.vue?vue&type=script&lang=js&"
export * from "./NewLines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports